"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Overlay = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../helpers");
const types_1 = require("./types");
const contentMods = {
    top: (0, styled_components_1.css) `
        align-items: stretch;
        justify-content: flex-start;
    `,
    bottom: (0, styled_components_1.css) `
        align-items: stretch;
        justify-content: flex-end;
    `,
    right: (0, styled_components_1.css) `
        align-items: flex-end;
        justify-content: flex-start;
        & > * {
            flex: 1 1;
        }
    `,
    left: (0, styled_components_1.css) `
        align-items: flex-start;
        justify-content: flex-start;
        & > * {
            flex: 1 1;
        }
    `,
    fill: (0, styled_components_1.css) `
        align-items: stretch;
        & > * {
            flex: 1 1;
        }
    `,
    center: (0, styled_components_1.css) `
        align-items: center;
        justify-content: center;
    `
};
const OverlayRoot = styled_components_1.default.div `
    position: ${({ fixed }) => (fixed ? 'fixed' : 'absolute')};
    top: ${({ topOffset }) => (topOffset ? `${topOffset}px` : 0)};
    left: 0;
    width: 100%;
    height: 100%;
    max-height: 100%;
    max-width: 100%;
    display: flex;
    outline: 0;
    border: 0;
    flex-direction: column;
    z-index: ${({ zIndex }) => zIndex};
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
    background-color: ${({ theme, view }) => theme.colors.backgrounds[view || types_1.OVERLAY_VIEW.ghost]};
    ${({ contentMod }) => contentMods[contentMod || types_1.OVERLAY_CONTENT_MOD.fill]}
    ${({ customColor }) => customColor && `background-color: ${customColor};`}
`;
exports.Overlay = (0, helpers_1.createUIElement)('Overlay', (_a, ref) => {
    var { className, fixed, view = types_1.OVERLAY_VIEW.ghost, contentMod = types_1.OVERLAY_CONTENT_MOD.fill, testId, zIndex = helpers_1.POPOVER_Z_INDEX, color, children, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style, topOffset } = _a, rest = __rest(_a, ["className", "fixed", "view", "contentMod", "testId", "zIndex", "color", "children", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style", "topOffset"]);
    return (react_1.default.createElement(OverlayRoot, Object.assign({}, rest, { "data-selector-id": testId || rest['data-selector-id'] || 'surface', className: `vm-Overlay ${className}`, fixed: fixed, topOffset: topOffset, view: view, customColor: color, contentMod: contentMod, zIndex: zIndex, onClick: (e) => {
            e.stopPropagation();
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
        }, onMouseDown: (e) => {
            e.stopPropagation();
            onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(e);
        }, onMouseUp: (e) => {
            e.stopPropagation();
            onMouseUp === null || onMouseUp === void 0 ? void 0 : onMouseUp(e);
        }, onMouseEnter: (e) => {
            e.stopPropagation();
            onMouseEnter === null || onMouseEnter === void 0 ? void 0 : onMouseEnter(e);
        }, onMouseLeave: (e) => {
            e.stopPropagation();
            onMouseLeave === null || onMouseLeave === void 0 ? void 0 : onMouseLeave(e);
        }, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }), children));
});
//# sourceMappingURL=Overlay.js.map